export default __webpack_public_path__ + "static/media/main-banner-5.8775420b.jpg";